import { z } from 'zod';

export type UserNotificationSetting = {
    id: number,
    number: string,
    name: string,
    symbolic_code: string,
    active: boolean,
    conditions: string,
    subject: string,
    body: string,
    legend: string,
};

export const UserNotificationSettingsSchema = z.object({
    id: z.number(),
    number: z.string(),
    name: z.string(),
    symbolic_code: z.string(),
    active: z.boolean(),
    conditions: z.string(),
    subject: z.string(),
    body: z.string(),
    legend: z.string(),
}).array();
